import { mapState, mapActions } from 'vuex'

export default {
  name: 'Toast',
  data () {
    return {
      defaultTitle: '',
      defaultBody: '',
      showTimer: null
    }
  },
  mounted () {
    this.showTimer = setTimeout(() => {
      this.hide()
    }, 10000)
  },
  beforeDestroy () {
    if (this.showTimer) {
      clearInterval(this.showTimer)
      this.showTimer = null
    }
  },
  computed: {
    ...mapState({
      active: state => state.toast.active,
      title: state => state.toast.title,
      body: state => state.toast.body
    }),
    getTitle () {
      return this.title || this.defaultTitle
    },
    getBody () {
      return this.body || this.defaultBody
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      // this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      hide: 'toast/hide'
    }),
    /**
     * ダイアログを閉じる
     */
    closeDialog () {
      this.hide()
    }
  }
}